import * as Long from "long";
export var selectTimesPurchasePackageAmount = function (state, id, isPaymentEntry) {
    if (isPaymentEntry === void 0) { isPaymentEntry = false; }
    var genericInfos = isPaymentEntry
        ? state.paymentInfo.purchasedPackages.get(id)
        : state.packageInfo.purchasedPackages.get(id);
    if (genericInfos === undefined || genericInfos.amount === undefined) {
        return Long.ZERO;
    }
    return genericInfos.amount;
};
export var selectIsPurchasePackageDataAvailableForPackage = function (state, id, isPaymentEntry) {
    if (isPaymentEntry === void 0) { isPaymentEntry = false; }
    var genericInfos = isPaymentEntry
        ? state.paymentInfo.purchasedPackages.get(id)
        : state.packageInfo.purchasedPackages.get(id);
    return genericInfos != undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectTimesPurchasePackageAmount.ts
// module id = 589
// module chunks = 3